import { observer } from "mobx-react-lite";
import { useField } from "react-final-form";

import { MessageBar, MessageBarType, NativeList, Text } from "@bps/fluent-ui";

import {
  reviewConditionNameOf,
  ReviewConditionUnlinkKeys
} from "./ReviewConditionModal.types.ts";

export const ReviewConditionModalWarning = observer(() => {
  const {
    input: { value: apptCondition }
  } = useField(reviewConditionNameOf("apptCondition"), {
    subscription: { value: true }
  });

  const {
    input: { value: unlinkCondition }
  } = useField(reviewConditionNameOf("unlinkCondition"), {
    subscription: { value: true }
  });

  if (!apptCondition && unlinkCondition !== ReviewConditionUnlinkKeys.unlink) {
    return null;
  }

  return (
    <MessageBar messageBarType={MessageBarType.warning}>
      <Text variant="small">
        If the following clinical data was recorded, it will be discarded when
        the consult is updated:
      </Text>
      <NativeList>
        <li>Consent and warnings</li>
        <li>Discharge</li>
        <li>Goals</li>
        <li>Injury</li>
        <li>Physio body diagrams</li>
        <li>Treatment plans</li>
      </NativeList>
    </MessageBar>
  );
});
